import Vue from "vue";
import { http } from "@/utils/http";
import {
  HasError,
  AlertError,
  AlertErrors,
  AlertSuccess,
} from "vform/src/components/bootstrap4";
import Form from "vform";

Vue.component(HasError.name, HasError);
Vue.component(AlertError.name, AlertError);
Vue.component(AlertErrors.name, AlertErrors);
Vue.component(AlertSuccess.name, AlertSuccess);

Vue.prototype.$Form = Form;

Form.prototype.submit = function submit(method, url, config = {}) {
  this.startProcessing();

  if (method === "get") {
    config.params = this.data();
  } else {
    config.data = this.data();
  }

  return new Promise((resolve, reject) => {
    http
      .request({
        url: this.route(url),
        method,
        ...config,
      })
      .then((response) => {
        this.finishProcessing();

        resolve(response);
      })
      .catch((error) => {
        this.busy = false;

        if (error.response) {
          this.errors.set(this.extractErrors(error.response));
        }

        reject(error);
      });
  });
};

Vue.prototype.$Form = (...params) => new Form(...params);
